import React from 'react';
import { PiSparkleFill } from 'react-icons/pi';
import { UIUser } from 'types';

const GeneratedSummary = ({ userProfileInfo, isSelf }: { userProfileInfo: UIUser; isSelf: boolean }) => {
	return (
		<div className="p-2 flex gap-2 bg-[#FFE5FF] rounded-lg @3xl/profile-introduction:max-w-[70%]">
			<div>
				<PiSparkleFill className="text-[#AC5DD9] min-w-[16px] min-h-[16px] max-w-[16px] max-h-[16px] md:max-w-[24px] md:max-h-[24px] md:min-w-[24px] md:min-h-[24px] w-full h-full" />
			</div>
			<p className="text-xs md:text-sm text-[#555770] font-inter font-[400]">
				{userProfileInfo?.profile?.userAiSummary?.aiSummary}
			</p>
		</div>
	);
};

export default GeneratedSummary;
